define('apps/course-intro/views/regions/badges/content',[
    'apps/course-intro/templates/regions/badges/content',
    'apps/course-intro/views/regions/badges/badge-grid',
    'components/asset-player/main',
    'components/transition/transition'
], function (template, BadgeGridView, assetPlayer, Transition) {
    "use strict";

    return Mn.LayoutView.extend({

        "template": template,

        "regions": {
            "grid": ".grid-region"
        },

        "onRender": function () {
            var playerChannel = assetPlayer.channel,
                modules = this.model.get('modules');

            modules.levelGuid = this.model.get('_id');
            modules.levelNum = this.model.get('levelNum');

            this.showChildView('grid', new BadgeGridView({
                "collection": modules
            }));

            playerChannel.command(playerChannel.Event.RENDER, {
                "target": this.$el
            });
        },

        "onShow": function(){
            Transition.create({
                "direction": Transition.Direction.DOWN,
                "context": this,
                "el": $('h1', this.el),
                "type": Transition.Type.FADE_IN,
                "duration": 1.2
            }).start();
        }
    });
});

